import React from 'react';
import styles from './Button.module.scss';
import type { ButtonProps } from './types';

import clsx from 'clsx';

export default function Button({ onClick, disabled, variant = 'basic', children, className, ...rest }: ButtonProps) {
	return (
		<button className={clsx(styles.button, styles[variant], className)} disabled={disabled} onClick={onClick} {...rest}>
			{children}
		</button>
	);
}
